import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'sm-back-title-bar',
  templateUrl: './back-title-bar.component.html',
  styleUrls: ['./back-title-bar.component.scss']
})
export class BackTitleBarComponent implements OnInit {

  @Output() onButtonClick: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() pageTitle: string = '';
  @Input() pageSubTitle: string = '';
  @Input() showBackButton: boolean = false;
  @Input('buttonText') showButton: string = '';
  @Input()
  headerCustomTemplate!: TemplateRef<any>;


  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
  }
  backButton(){
this.router.navigate(['../'], {queryParamsHandling: 'preserve', relativeTo: this.route})
  }

  onTitlebarButtonClick(){
    this.onButtonClick.emit(true);
  }
}
